import React from 'react';
import { slideWrapper } from '../components/slide';
import { Timer } from '../components/timer';
import { Content } from '../components/content';
import { SlideImage } from '../components/slide-image';
import { PuzzleItem, PuzzleItemsWrapper } from '../components/puzzle-item';
import { useConfirmation } from '../../generic/hooks/use-confirmation';

export const TeslaPuzzle1 = slideWrapper(({ data, step, getImg }) => {
  const { answers } = step;

  const ConfirmationPopup = useConfirmation(1);
  return (
    <>
      <ConfirmationPopup />
      <Timer data={data} presentation />

      <Content left={4} top={5} xNotCenter yNotCenter>
        <SlideImage width="150px" rotate={'-10deg'} src={getImg('pytajnik')} show={true} />
      </Content>
      <Content left={20} top={14} yNotCenter>
        <SlideImage width="350px" src={getImg('lornetka')} show={true} />
      </Content>
      <PuzzleItemsWrapper>
        <PuzzleItem getImg={getImg} letter="a" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="b" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="c" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="d" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="e" answers={answers} smallItem />
      </PuzzleItemsWrapper>
    </>
  );
});
